import { useTranslation } from 'react-i18next';
import type { OpenLDAPTranslation } from '../../types/openldap';

export function useOpenLDAPTranslation() {
  const { t, i18n } = useTranslation('openldap');

  return {
    t,
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage,
    isRTL: i18n.dir() === 'rtl',
    getOpenLDAPTranslation: (): OpenLDAPTranslation => ({
      title: t('title'),
      subtitle: t('subtitle'),
      hero: {
        title: t('hero.title'),
        description: t('hero.description'),
        buttonText: t('hero.buttonText')
      },
      features: {
        title: t('features.title'),
        items: t('features.items', { returnObjects: true })
      },
      benefits: {
        title: t('benefits.title'),
        description: t('benefits.description'),
        items: t('benefits.items', { returnObjects: true })
      }
    })
  };
}